module.exports = __webpack_public_path__ + "img/jointhepractice.d3afd0e9.svg";